import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import FireAlarmStatisticsComponent from "./FireAlarmStatisticsComponent";
import { apiWrapper } from "../../../apis/CommonApi";
import * as fireonApi from "../../../apis/FireOnApi";
import { getYear } from "../../../utils/date";
import FireAlarmStatisticsTypeComponent from "./FireAlarmStatisticsTypeComponent";

export default function FireAlarmStatisticsRoutes() {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    apiWrapper(async () => {
      const searchYear = getYear(new Date());
      const { status, data } = await fireonApi.getFireAlarmStatistics(
        searchYear
      );
      if (status === true) {
        setLinks([
          {
            path: "/event-month/",
            title: "수신기 동작 유형별",
            data: data.eventMonthStats,
          },
          {
            path: "/event-type/",
            title: "이벤트 항목별",
            data: data.eventTypeStats,
          },
          {
            path: "/hour/",
            title: "발생시간대별",
            data: data.hourStats,
          },
          {
            path: "/weekday/",
            title: "발생요일별",
            data: data.weekdayStats,
          },
        ]);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  return (
    <Routes>
      <Route path="*" element={<FireAlarmStatisticsComponent />} />
      {links &&
        links.map((link) => (
          <Route
            key={link.path}
            path={link.path}
            element={
              <FireAlarmStatisticsTypeComponent
                title={link.title}
                data={link.data}
              />
            }
          />
        ))}
    </Routes>
  );
}
